import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { dateFormatter } from '../../plugins/helper';
import { bucketObj } from "../../environment";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";

const RefundDetails = () => {
  const MySwal = withReactContent(Swal);
  const navigate = useNavigate();
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || {});
  const [refundRequests, setRefundRequests] = useState(null);
  const refundID = useSelector((state) => state.refund_Id)
  
  const [status, setStatus] = useState("pending");
  console.log('refundID',refundID);
  useEffect(() => {
    async function fetchData() {
        try {
          if(!refundRequests)
          {
            const result = await axios.get("getrefundrequestbyId?_id="+refundID);
            console.log('result.data.refundRequest',result.data.refundRequest);
            if(result?.data?.message)
            {
              setRefundRequests(result.data);
            }
            else
            {
              setRefundRequests(result.data.refundRequest);
              setStatus(result.data?.refundRequest?.refundStatus);
            }     
          }  
        } catch (error) {
            console.error('Error fetching refund requests:', error);
        }
    }
    fetchData();
}, [refundID]);

  const goBack = () => {
    navigate("/refunds")
  }

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

  const handleSubmit = async () => {
    const payload = {
      _id: refundRequests?._id,
      refundStatus: status,
      customerName: refundRequests?.shippingAddress?.name,
      orderId: refundRequests?.orderId,
      refundAmount:refundRequests?.grossTotal || 0,
      email: refundRequests?.shippingAddress?.email
    };
console.log('payload',payload);
    try {
      const response = await axios.post('updaterefundstatus', payload);
      console.log('Update response:', response.data);
      
      if (response.data.status == "success") {
        MySwal.fire({
          position: "top-end",
          icon: "success",
          title: "Status updated Successfully!",
          showConfirmButton: false,
          timer: 3000,
          }).then(() => {
              goBack();
          });
      
      } else {
        MySwal.fire({
          position: "top-end",
          icon: "error",
          title: "Failed to update refund status!",
          showConfirmButton: false,
          timer: 3000,
          }).then(() => {
              goBack();
          });
      }
      
    } catch (error) {
      console.error('Error updating refund status:', error);
      alert("An error occurred while updating the refund status.");
    }
  };

  return (
    <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
      <div className="content">
        {/* <div className="page-header"> */}
        <div>
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>{t[l]?.["refund_requests"] || "Refund Requests"}</h4>
              <h6 className='mt-2 mb-4' style={{fontSize: "14px",color: "#495057",fontWeight: "400"}}>{t[l]?.["manage_your_returns"] || "Manage Your Returns"}</h6>
            </div>
          </div>
          
          <div className="card shadow-sm">
                <div className="card-body">
                  {/* <h2 className="mb-4">Refund Requests</h2>
                 <p> Manage your Returns</p> */}

                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <strong>Order ID:</strong> {refundRequests?.orderId || ""}
                      </div>

                      <div className="mb-3">
                        Purchased on {dateFormatter(refundRequests?.createdAt) || ""}
                      </div>

                      <div className="mb-3">
                        <strong>Reason:</strong> <br/>{refundRequests?.reason || ""}
                      </div>

                      <div className="mb-3">
                        <strong>Buyer’s Comments:</strong> <br/>{refundRequests?.comments || ""}
                      </div>
                      <div className="mb-4">
                        <strong>Uploaded Evidence:</strong>
                        <div className="mt-2">
  {refundRequests?.contentUrl?.match(/\.(mp4|webm|ogg)$/i) ? (
    <video
      width="320"
      height="240"
      controls
      className="img-fluid img-thumbnail"
      style={{ maxWidth: '200px' }}
    >
      <source src={bucketObj.bucketUrl + bucketObj.objectKey + refundRequests?.contentUrl} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  ) : (
    <img
      src={bucketObj.bucketUrl + bucketObj.objectKey + refundRequests?.contentUrl || "https://via.placeholder.com/150"}
      alt="Uploaded Evidence"
      className="img-fluid img-thumbnail"
      style={{ maxWidth: '200px' }}
    />
  )}
                      </div>

                      </div>
                     
                    </div>

                    <div className="col-md-6">
                     
                    <div className="mb-3">
                        <strong>Return Number:</strong> {refundRequests?._id || ""}
                      </div>

                      <div className="mb-3">
                        <strong>Quantity:</strong> {refundRequests?.products?.length}
                      </div>

                      <div className="mb-4">
                      <strong>Shipping Address:</strong><br/>
                        {refundRequests?.shippingAddress?.name}<br/>
                        {refundRequests?.shippingAddress?.address},  {refundRequests?.shippingAddress?.state}, {refundRequests?.shippingAddress?.zipCode}<br/>
                        {refundRequests?.shippingAddress?.country}<br/>
                      </div>
                      <div className="mb-4">
                    <strong>Product Names:</strong><br />
                    {refundRequests?.products?.map(product => product.name).join(', ') || "No products"}
                  </div>

                      <div className="mb-4">
                          <strong>Status:</strong>
                        <select
                          id="status"
                          className="form-select"
                          value={ status }
                          onChange={handleStatusChange}
                        >
                          <option value="pending">Pending</option>
                          <option value="approve">Approve</option>
                          <option value="reject">Reject</option>
                        </select>
                      </div>

                      <div className="d-flex justify-content-end">
                        <button className="btn btn-primary" onClick={handleSubmit}>
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>

                </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default RefundDetails;